export default __webpack_public_path__ + "static/media/AW2.a04db297.jpg";